import { estimateFare } from "../../../../../../api/fare/estimateFare";

const hasCoordinate = (point) =>
  point &&
  Number.isFinite(Number(point.lat)) &&
  Number.isFinite(Number(point.lng));

const validateEstimateFare = (fare) => {
  if (!hasCoordinate(fare?.origin)) return "ORIGEN INVALIDO";
  if (!hasCoordinate(fare?.destination)) return "DESTINO INVALIDO";
  if (!Number.isFinite(Number(fare?.vehicleId))) return "VEHICULO INVALIDO";
  if (!fare?.date) return "FECHA INVALIDA";
  if (!fare?.time) return "HORA INVALIDA";
  if (!Number.isFinite(Number(fare?.distanceKm))) return "DISTANCIA INVALIDA";
  if (!Number.isFinite(Number(fare?.durationMinutes))) return "DURACION INVALIDA";
  if (!Number.isFinite(Number(fare?.nationality))) return "NACIONALIDAD INVALIDA";
  return "";
};

export const EstimateFareUseCase = async (fare) => {
  const validationError = validateEstimateFare(fare);
  if (validationError) {
    return {
      message: "validation_error",
      error: validationError,
    };
  }

  try {
    const response = await estimateFare(fare);
    return response.data;
  } catch (error) {
    return (
      error?.response?.data || {
        message: "estimate_fare_error",
        error: error.message,
      }
    );
  }
};
